<template>
  <div class="chat-message">
    <div
      class="flex"
      :class="[comment.commentator_id === auth.id ? 'justify-end' : '']"
    >
      <div
        class="order-1 mx-2 flex max-w-xs flex-col text-xs"
        :class="[
          comment.commentator_id === auth.id
            ? 'order-1 items-end'
            : 'order-2 items-start'
        ]"
      >
        <div>
          <div
            class="inline-block rounded-lg"
            :class="[
              comment.commentator_id === auth.id
                ? 'rounded-br-none bg-blue-300 '
                : 'rounded-bl-none bg-gray-500 text-white',
              'w-full text-white'
            ]"
          >
            <div class="px-4 py-2">
              <p>{{ comment.original_text }}</p>
            </div>
          </div>
          <div
            v-if="comment.reactions?.length > 0"
            class="relative bottom-1 left-1"
          >
            <div
              class="flex min-w-min max-w-min gap-x-0.5 rounded-lg bg-gray-300 p-1"
            >
              <template
                v-for="(commentators, reaction) in formattedReactions"
                :key="reaction"
              >
                <ChatReactionList
                  :is-other-person-comment="comment.commentator_id === auth.id"
                  :reaction="reaction"
                  :commentators="commentators"
                  icon-color="white"
                />
              </template>
              <div
                v-if="comment.reactions.length > 1"
                class="ml-2 cursor-default select-none rounded-full bg-primary-500 px-1 text-white"
              >
                {{ comment.reactions.length }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex w-full flex-row items-center justify-between gap-x-2 px-2 pt-1 text-gray-500"
        >
          <div
            class="cursor-default select-none text-xs font-light text-slate-400"
          >
            {{ formattedDisplayedTime }}
          </div>
          <ReactionOptionMenu @reaction-selection="handleAddReaction" />
          <FontAwesomeIcon
            v-if="comment.commentator_id === auth.id || authIsSuperAdmin"
            :icon="['fas', 'trash']"
            class="cursor-pointer text-gray-500"
            @click="handleCommentDeletion"
          />
        </div>
      </div>
      <div
        :class="[comment.commentator_id === auth.id ? 'order-2' : 'order-1']"
        class="pb-4"
      >
        <AvatarComponent :user_id="comment.commentator_id" />
      </div>
    </div>
    <div v-if="isReplyTextAreaVisible" class="flex w-1/3 flex-col">
      <BaseShowEditTextArea v-model="internalReply" :edition-mode="true" />
      <BaseButton :title="$t('button.reply')" @click="handleCommentReply" />
    </div>
  </div>
</template>

<script>
import AvatarComponent from '@c/AvatarComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import ReactionOptionMenu from '@c/addf-package/components/chat/ReactionOptionMenu.vue'
import ChatReactionList from '@c/addf-package/components/chat/ChatReactionList.vue'
import BaseShowEditTextArea from '@c/addf-package/components/BaseShowEditInput/BaseShowEditTextArea.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'CommentBubble',
  components: {
    BaseButton,
    FontAwesomeIcon,
    BaseShowEditTextArea,
    ChatReactionList,
    ReactionOptionMenu,
    AvatarComponent
  },
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  emits: ['commentDeletion', 'commentReaction', 'commentReply'],
  data() {
    return {
      isReplyTextAreaVisible: false,
      internalReply: null
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth',
      initialMetadata: 'metadata/getInitialMetadata'
    }),
    formattedReactions() {
      if (!this.comment.reactions) return null
      return this.comment.reactions.reduce((old, curr) => {
        if (
          typeof old === 'object' &&
          !Object.keys(old).includes(curr.reaction)
        ) {
          let arrayOfSameReaction = this.comment.reactions.filter(
            (reaction) => reaction.reaction === curr.reaction
          )
          console.log('arrayOfSameReaction', arrayOfSameReaction)
          old[curr.reaction] = arrayOfSameReaction.reduce(
            (oldReaction, currReaction) => {
              oldReaction.push(currReaction.commentator_id)
              return oldReaction
            },
            []
          )
          return old
        }
        return old
      }, {})
    },
    options() {
      return [
        {
          label: this.$t('button.delete'),
          icon: 'trash',
          bgColor: 'bg-gradient-to-b from-red-600 to-red-700',
          fgColor: 'text-white',
          clickFunction: (comment) => this.handleCommentDeletion(comment)
        }
      ]
    },
    formattedDisplayedTime() {
      return moment(this.comment.approved_at).format('DD/MM/YYYY HH:mm')
    },
    authIsSuperAdmin() {
      return this.auth.roles[0] === 'super-admin'
    }
  },
  methods: {
    handleAddReaction(reaction) {
      this.$emit('commentReaction', {
        comment_id: this.comment.id,
        reaction: reaction
      })
    },
    handleCommentReplyToggle() {
      if (this.isReplyTextAreaVisible === true) this.internalReply = null
      this.isReplyTextAreaVisible = !this.isReplyTextAreaVisible
    },
    handleCommentReply() {
      this.$emit('commentReply', {
        comment_id: this.comment.id,
        text: this.internalReply
      })
      this.internalReply = null
      this.isReplyTextAreaVisible = false
    },
    handleCommentDeletion() {
      this.$emit('commentDeletion', this.comment.id)
    }
  }
}
</script>
